import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {OrderForm} from '../models/order-form';

export const orderAddActionTypes = {
  ADD: type('[orders] Add'),
  ADD_SUCCESS: type('[orders] Add Success'), // don't change this type because listening in order-detail.components
  ADD_NO_PLAYER_SUCCESS: type('[orders] Add No Player Success'),
  ADD_FAIL: type('[orders] Add Fail'),
};

export class AddOrdersAction implements Action {
  readonly type = orderAddActionTypes.ADD;
  constructor(public payload?: {renew: boolean, order: OrderForm}) {}
}

export class AddOrdersSuccessAction implements Action {
  readonly type = orderAddActionTypes.ADD_SUCCESS;
  constructor(public payload?: boolean) {}
}
export class AddOrdersNoPlayerSuccessAction implements Action {
  readonly type = orderAddActionTypes.ADD_NO_PLAYER_SUCCESS;
  constructor(public payload?: boolean) {}
}

export class AddOrdersFailAction implements Action {
  readonly type = orderAddActionTypes.ADD_FAIL;
  constructor(public payload?: string) {}
}
